import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';
import withModal from 'components/modals/withModal';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { destroyAccountContacts } from 'redux/actions/contactActions';
import ConfirmationModal from '../../modals/ConfirmationModal';
import { DEFAULT_CONTACT_QUERY_PARAMS } from '../../../containers/Accounts/AccountDetail/ContactsTab/index';
import { SELECT_ALL_SUCCESS } from '../../../constants/config';

class DeleteBulkModal extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool,
    selectedContacts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      contact_id: PropTypes.string,
    })).isRequired,
    account: PropTypes.shape({
      id: PropTypes.number,
    }).isRequired,
    getContacts: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    destroyAccountContacts: PropTypes.func.isRequired,
    showNotification: PropTypes.func.isRequired,
    isSelectedAllContacts: PropTypes.bool.isRequired,
    countContacts: PropTypes.number.isRequired,
    removeSelection: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isOpen: false,
  };

  handleSubmit = async () => {
    // eslint-disable-next-line no-debugger
    const {
      account,
      getContacts,
      toggle,
      selectedContacts,
      showNotification,
      isSelectedAllContacts,
      preparedParams,
    } = this.props;

    toggle();

    // eslint-disable-next-line no-unused-expressions
    isSelectedAllContacts && showNotification(
      SELECT_ALL_SUCCESS,
      'success',
    );

    const sequenceIds = Array.from(new Set(selectedContacts.map(obj => obj.current_campaign_sequences
      .map(el => el.sequence)).flat()));
    // eslint-disable-next-line no-unused-expressions
    !isSelectedAllContacts && await this.props.destroyAccountContacts(
      account.id,
      {
        contact_ids: selectedContacts.map(obj => obj.contact_id),
        sequence_ids: sequenceIds,
      },
    );

    // eslint-disable-next-line no-unused-expressions
    isSelectedAllContacts && await this.props.destroyAccountContacts(
      account.id,
      {
        contact_ids: selectedContacts.map(obj => obj.contact_id),
        sequence_ids: sequenceIds,
      },
      {
        ...preparedParams,
        ...DEFAULT_CONTACT_QUERY_PARAMS,
        ...{ all: true },
      },
    );
    // eslint-disable-next-line no-unused-expressions
    !isSelectedAllContacts &&
    showNotification(`${selectedContacts.length} contacts were successfully deleted`, 'success');
    this.props.removeSelection();
    await getContacts({ ...preparedParams });
  }

  render() {
    const {
      toggle, isOpen, selectedContacts, isSelectedAllContacts, countContacts,
    } = this.props;
    return (
      <ConfirmationModal
        open={isOpen}
        onBackdropClick={toggle}
        title="Confirm"
        confirmLabel="Yes"
        onConfirmClick={this.handleSubmit}
        onCancelClick={toggle}
      >
        <React.Fragment>
          <span className="volt-modal--stressed">
            {isSelectedAllContacts ? countContacts : selectedContacts.length} contacts&nbsp;
          </span>&nbsp;
            will be <span className="volt-modal--red">DELETED</span> from this account, are you sure?
        </React.Fragment>
      </ConfirmationModal>
    );
  }
}

export default compose(connect(
  state => ({
    account: state.account,
  }),
  {
    destroyAccountContacts,
  },
))(withModal(DeleteBulkModal));
